import type { FC } from 'react';

import { ArrowMediumRight32, Checkmark32 } from '@packages/themes/icons';
import { ListItem, ListItemButton, ListItemText } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

export const FilterListMobileItemFragment = graphql(/* GraphQL */ `
  fragment FilterListMobileItemFragment on SearchFilterBase {
    id
    displayName
  }
`);

export type FilterListMobileItemProps = {
  maskedData: FragmentType<typeof FilterListMobileItemFragment>;
  /** Ids of all currently used filters
   * @default []
   */
  /** If `true`, render the filter differently to communicate that it is currently in use */
  isActive?: boolean;
  /** Callback fired when an individual filter is clicked  */
  onClick?: (filterId: string) => void;
};

/**
 * A simple list of selectable filters, for mobile
 * */
export const FilterListMobileItem: FC<FilterListMobileItemProps> = ({
  maskedData,
  isActive,
  onClick,
}) => {
  const { id, displayName } = getFragmentData(FilterListMobileItemFragment, maskedData);

  return (
    <ListItem sx={{ padding: 0 }}>
      <ListItemButton key={id} divider onClick={() => onClick?.(id)}>
        <ListItemText>{displayName}</ListItemText>
        {isActive ? (
          <Checkmark32 aria-label="active" sx={{ transform: 'scale(0.5)' }} />
        ) : (
          <ArrowMediumRight32 />
        )}
      </ListItemButton>
    </ListItem>
  );
};
